import React, { createContext, useContext } from 'react'

export type CallNotesRequest = { uid: string; callID: string }

const CallNotesRequestContext = createContext<CallNotesRequest | null>(null)

// A new object per request, so asking twice for the same call still reaches the logger.
export const CallNotesRequestProvider = ({
  value,
  children,
}: {
  value: CallNotesRequest | null
  children: React.ReactNode
}) => <CallNotesRequestContext.Provider value={value}>{children}</CallNotesRequestContext.Provider>

export const useCallNotesRequest = (): CallNotesRequest | null => useContext(CallNotesRequestContext)

const LinkedCallContext = createContext('')

export const LinkedCallProvider = LinkedCallContext.Provider

// The call the logger was opened for; empty when the coach picked the type themselves.
export const useLinkedCallPrefill = (): string => useContext(LinkedCallContext)
